import { useMemo } from 'react';

import useComponentTypesQuery from './useComponentTypesQuery';

/**
 * @description This hook is used to get the component type id by variant type
 * @param variantType - The variant type to get the component type id for
 * @returns The component type id for the given variant type
 */

const useGetComponentTypeIdByVariant = (
    variantType: string,
): string | undefined => {
    const { data: componentTypes } = useComponentTypesQuery();

    const componentTypeId = useMemo<string | undefined>(() => {
        return componentTypes?.map[variantType]?.id;
    }, [componentTypes, variantType]);

    return componentTypeId;
};

export default useGetComponentTypeIdByVariant;
